export class SessionService {
	public static getJWT(): string {
		const jwt = localStorage.getItem('kauth');

		if (!jwt) {
			this.logout();
		}

		return jwt as string;
	}

	public static logout(): void {
		localStorage.removeItem('kauth');
		window.location.href = '';
	}
}
